import { fromJS } from 'immutable';
import { get } from 'lodash';

import { SET_PREOPEN_MANAGER_REJECTED_CLAIMS } from 'containers/PreOpenManagerRejectedClaims/constants';
import { RESET_STORE } from 'containers/LoginPage/constants';

const initialState: any = fromJS({
  claims: [],
  countClaims: 0,
});

const preOpenManagerRejectedClaimsReducer = (
  state = initialState,
  action: any,
) => {
  switch (action.type) {
    case SET_PREOPEN_MANAGER_REJECTED_CLAIMS:
      return state
        .set('claims', fromJS(get(action.response, 'claims', [])))
        .set('countClaims', fromJS(get(action.response, 'total', 0)));
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default preOpenManagerRejectedClaimsReducer;
